import React from "react";
import { Line } from "react-chartjs-2";
import "./registerCharts";
import { fmtKop } from "../../utils/format";

// weekly: [{ week_label, plan_kop, fact_kop, is_future }]
export default function WeeklyBurnUp({ weekly, target }) {
  if (!weekly || weekly.length === 0) {
    return <div style={{ color: "var(--text-mute)", padding: 24 }}>Нет недельных данных.</div>;
  }
  const labels = weekly.map((w) => w.week_label);

  const data = {
    labels,
    datasets: [
      {
        label: "План (к цели)",
        data: weekly.map((w) => w.plan_kop / 100),
        borderColor: "#5c6b7e",
        borderDash: [6, 5],
        pointRadius: 0,
        tension: 0,
      },
      {
        label: "Факт",
        data: weekly.map((w) => (w.is_future ? null : w.fact_kop / 100)),
        borderColor: "#4f7cff",
        backgroundColor: "rgba(79,124,255,0.12)",
        fill: true,
        pointRadius: 3,
        spanGaps: false,
        tension: 0.2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { labels: { boxWidth: 14 } },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            ctx.parsed.y == null
              ? null
              : `${ctx.dataset.label}: ${fmtKop((ctx.parsed.y || 0) * 100, { short: true })}`,
        },
      },
    },
    scales: {
      y: {
        suggestedMax: (target || 0) / 100,
        ticks: { callback: (v) => fmtKop(v * 100, { short: true }) },
      },
      x: { ticks: { maxRotation: 60, minRotation: 45, autoSkip: true, maxTicksLimit: 12 } },
    },
  };

  return (
    <div style={{ height: 300 }}>
      <Line data={data} options={options} />
    </div>
  );
}
